import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "remixicon/fonts/remixicon.css";

import App from "./components/App";
import Register from "./components/Register/Register";
import VerifyNumber from "./components/VerifyNumber/VerifyNumber";
import Forgot from "./components/Forgot/Forgot";
import { Fragment } from "react";
const root = ReactDOM.createRoot(document.getElementById("root"));

const Connection = new (require("./classes/Connection").default)();

root.render(
    <Fragment>
        <BrowserRouter>
            <Routes>
                <Route
                    path='/register/*'
                    element={<Register connection={Connection} />}
                />
                <Route
                    path='/verify-number/:mode/*'
                    element={<VerifyNumber connection={Connection} />}
                />
                <Route
                    path='/forgot/:mobile/:code'
                    element={<Forgot connection={Connection} />}
                />
                <Route path='*' element={<App connection={Connection} />} />
            </Routes>
        </BrowserRouter>
    </Fragment>
);
